const LoadingSpinner = () => {
  return (
    <div className="position-absolute top-50 start-50 translate-middle">
      <span
        className="spinner-border text-primary"
        style={{ width: "3rem", height: "3rem" }}
      />
    </div>
  );
};
export default LoadingSpinner;
